module.exports = __webpack_public_path__ + "static/media/globalIcon.fa53c349.svg";